import React, { useEffect, useState } from 'react';
import { useCartCache } from '../context/CartCacheContext';
import { numpad } from '../../../../../../../shared/lib/time';
import Icon from './Icon';

function msToClock(ms: number) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;

  if (h > 0) return `${h}:${numpad(m)}:${numpad(s)}`;
  return `${numpad(m)}:${numpad(s)}`;
}

function coerceDate(d: any): Date | null {
  if (!d) return null;
  if (d instanceof Date) return d;
  const parsed = new Date(d);
  return Number.isFinite(parsed.getTime()) ? parsed : null;
}

function useExpiryCountdown(expiresAtInput: any) {
  const [now, setNow] = useState(() => Date.now());
  const expiresAt = coerceDate(expiresAtInput);

  useEffect(() => {
    if (!expiresAt) return;

    const id = window.setInterval(() => setNow(Date.now()), 1000);
    const t = window.setTimeout(() => setNow(Date.now()), 50);

    return () => {
      window.clearInterval(id);
      window.clearTimeout(t);
    };
  }, [expiresAt?.getTime()]);

  if (!expiresAt) return { msLeft: null as number | null, label: null as string | null };

  const msLeft = expiresAt.getTime() - now;
  const label = msLeft <= 0 ? null : msToClock(msLeft);

  return { msLeft, label };
}

interface CartTimerProps {
  hideWhenExpired?: boolean;
}

export default function CartTimer(props: CartTimerProps) {
  const { hideWhenExpired = true } = props;
  const { cart } = useCartCache();
  const expiresAt = cart?.expiresAt;

  const { msLeft, label } = useExpiryCountdown(expiresAt);

  const expired = msLeft != null && msLeft <= 0;
  const show = label != null && (!expired || !hideWhenExpired);

  if (!show) return null;

  return (
    <div className="flex items-center justify-center font-bold go-cart-banner">
      <Icon icon={['fass', 'clock']} className="mr-1" />
      <div>
        <span>Your cart is reserved for&nbsp;</span>
        <span className="text-emphasis monospace go-timer">{label}</span>
      </div>
    </div>
  );
}
